import { render } from "./searchCat.vue?vue&type=template&id=bdff4552"
import script from "./searchCat.vue?vue&type=script&lang=js"
export * from "./searchCat.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__